import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationAPI } from "../api/NotificationApi";

export function useReadNotification() {
  const queryClient = useQueryClient();
  const queryKey = [`notifications`];

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return NotificationAPI.readNotification(data.id);
    },
    onSuccess: (successData: any) => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
      });
    },
  });

  return { mutation };
}
